module.exports = __webpack_public_path__ + "img/12-C4T.90b338d.jpg";